// Email context types mapping for Email Notifications page
// Maps context_type values from backend to user-friendly labels with source and trigger information

export const EMAIL_CONTEXTS = [
  { 
    key: 'TRAINING', 
    label: 'Training', 
    source: 'Training module', 
    trigger: 'Trigger Email for Training' 
  },
  { 
    key: 'POLICY_CENTER_FOR_APPROVAL', 
    label: 'Document Center — For Approval', 
    source: 'Document Center', 
    trigger: 'Submit for Approval' 
  },
  { 
    key: 'POLICY_CENTER_APPROVED', 
    label: 'Document Center — Approved', 
    source: 'Document Center', 
    trigger: 'Approval Action' 
  },
  { 
    key: 'POLICY_CENTER_REJECTED', 
    label: 'Document Center — Rejected', 
    source: 'Document Center', 
    trigger: 'Rejection Action' 
  },
  { 
    key: 'POLICY_PUBLISHED', 
    label: 'Policy — Published', 
    source: 'Document Center', 
    trigger: 'Publish Action' 
  },
  { 
    key: 'ORGANIZATION_ONBOARDING_COMPLETION', 
    label: 'Organization — Onboarding Completed', 
    source: 'Organization', 
    trigger: 'Onboarding Completed' 
  },
  { 
    key: 'USER_WELCOME', 
    label: 'User — Welcome', 
    source: 'Users', 
    trigger: 'User Created/Signup' 
  },
  { 
    key: 'ONBOARDING_ENGAGEMENT_ADMIN', 
    label: 'Onboarding — Admin Engagement', 
    source: 'Users', 
    trigger: 'Admin Onboarding' 
  },
  { 
    key: 'ONBOARDING_ENGAGEMENT_MEMBER', 
    label: 'Onboarding — Member Engagement', 
    source: 'Users', 
    trigger: 'Member Onboarding' 
  },
  { 
    key: 'SIGNUP_COMPLETION_TO_ADMIN', 
    label: 'Signup Completion — Admin Notice', 
    source: 'Users', 
    trigger: 'Signup Completed' 
  },
  { 
    key: 'USER_PASSWORD_RESET', 
    label: 'User — Password Reset', 
    source: 'Users', 
    trigger: 'Password Reset/Expiry' 
  },
  {
    key: 'VERIFY_RECOVERY_OTP',
    label: 'Verify — Recovery OTP',
    source: 'Verify service',
    trigger: 'Recovery OTP'
  },
  {
    key: 'VERIFY_CREATION_OTP',
    label: 'Verify — Creation OTP',
    source: 'Verify service',
    trigger: 'Creation OTP'
  }
];

// Helper function to get context label by key
export const getContextLabel = (key) => {
  const context = EMAIL_CONTEXTS.find(c => c.key === key);
  return context ? context.label : key;
};

// Helper function to get full context info by key
export const getContextInfo = (key) => {
  return EMAIL_CONTEXTS.find(c => c.key === key) || { 
    key, 
    label: key, 
    source: 'Unknown', 
    trigger: 'Unknown' 
  };
};
